import type { LucideIcon } from 'lucide-react'
import styles from './IconToggle.module.css'

type Props = {
	on: boolean
	onChange: (next: boolean) => void
	icon: LucideIcon
	ariaLabel: string
}

// Slide switch with an icon riding in the knob — the icon lights up and the
// track fills when on, no label needed. Shared by the todo priority switch
// and the recipe keep-screen-on toggle so they stay visually identical.
export const IconToggle = ({ on, onChange, icon: Icon, ariaLabel }: Props) => (
	<button
		type="button"
		className={`${styles.toggle} ${on ? styles.on : ''}`.trim()}
		role="switch"
		aria-checked={on}
		aria-label={ariaLabel}
		onClick={() => onChange(!on)}
	>
		<span className={styles.knob}>
			<Icon
				className={styles.icon}
				size={18}
				aria-hidden="true"
				fill={on ? 'currentColor' : 'none'}
			/>
		</span>
	</button>
)
